function setZIndexesForElements (divs, startIndex) {
  let baseZIndex = 0
  if (startIndex !== undefined) {
    baseZIndex = startIndex
  }
  // var divs = document.getElementsByClassName('article-layer')
  var divArray = []
  for (var i = 0; i < divs.length; i++) {
    // divs[i].style.zIndex = i
    divArray.push(divs[i])
  }

  divArray.sort(sortBy(true))

  for (var j = 0; j < divArray.length; j++) {
    divArray[j].style.zIndex = j + baseZIndex
  }
}

function sortBy (reverse) {
  // Move smaller items towards the front
// or back of the array depending on if
// we want to sort the array in reverse
// order or not.
  var moveSmaller = reverse ? 1 : -1

// Move larger items towards the front
// or back of the array depending on if
// we want to sort the array in reverse
// order or not.
  var moveLarger = reverse ? -1 : 1

/**
 * @param  {*} object1
 * @param  {*} object2
 * @return {Number}
 */
  return function (object1, object2) {
    if ((object1.getBoundingClientRect().width * object1.getBoundingClientRect().height) < (object2.getBoundingClientRect().width * object2.getBoundingClientRect().height)) {
      return moveSmaller
    }
    if ((object1.getBoundingClientRect().width * object1.getBoundingClientRect().height) > (object2.getBoundingClientRect().width * object2.getBoundingClientRect().height)) {
      return moveLarger
    }
    return 0
  }
}

export { setZIndexesForElements }
